export default __webpack_public_path__ + "static/media/Vijay-IIT-Hyderabad-e1518458326252.bd15531e.jpg";